import { motion } from "framer-motion"
import PropTypes from "prop-types"
import { forwardRef } from "react"

const defaultVariants = {
  hide: {
    height: 0,
    overflow: "hidden",
    transition: { ease: "easeOut" },
    transitionEnd: { display: "none" },
  },
  show: {
    display: "block",
    height: "auto",
    transition: { ease: "easeOut" },
    transitionEnd: { overflow: "visible" },
  },
}

const Expand = forwardRef(({ children, show, variants, ...props }, ref) => (
  <motion.div
    animate={show ? "show" : "hide"}
    exit="hide"
    initial="hide"
    ref={ref}
    variants={variants || defaultVariants}
    {...props}
  >
    {children}
  </motion.div>
))

Expand.displayName = "Expand"

Expand.propTypes = {
  children: PropTypes.node,
  show: PropTypes.bool,
  variants: PropTypes.object,
}

export default Expand
